import { noop } from '@sgme/fp';
import { createContext } from 'react';
import type { DataById } from 'state/formData/formData.model';

export interface DataApi {
  setFieldValue: (key: string, value: unknown) => void;
}

export const emptyApi: DataApi = {
  setFieldValue: noop,
};

export const DataContext = createContext<readonly [DataById, DataApi]>([{}, emptyApi]);
